interface CloudIconProps {
  isActive?: boolean;
  className?: string;
}

const CloudIcon = ({ isActive, className, ...rest }: CloudIconProps) => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_795_104)">
        <path
          d="M32.25 16.7334C31.6902 13.8963 30.1627 11.3415 27.9284 9.50549C25.6942 7.66947 22.8918 6.66609 20 6.66675C15.1833 6.66675 11 9.40008 8.91667 13.4001C6.46706 13.6648 4.20168 14.8254 2.55581 16.6589C0.909952 18.4925 -0.00028617 20.8695 6.74879e-08 23.3334C6.74879e-08 25.9856 1.05357 28.5291 2.92893 30.4045C4.8043 32.2798 7.34784 33.3334 10 33.3334H31.6667C32.761 33.3334 33.8447 33.1179 34.8557 32.6991C35.8667 32.2803 36.7854 31.6665 37.5592 30.8926C38.333 30.1188 38.9469 29.2002 39.3657 28.1891C39.7845 27.1781 40 26.0944 40 25.0001C40 20.6001 36.5833 17.0334 32.25 16.7334ZM31.6667 30.0001H10C8.23189 30.0001 6.5362 29.2977 5.28595 28.0475C4.03571 26.7972 3.33333 25.1015 3.33333 23.3334C3.33333 19.9167 5.88333 17.0667 9.26667 16.7167L11.05 16.5334L11.8833 14.9501C12.6498 13.458 13.8131 12.2064 15.2452 11.3331C16.6773 10.4597 18.3226 9.99845 20 10.0001C24.3667 10.0001 28.1333 13.1001 28.9833 17.3834L29.4833 19.8834L32.0333 20.0667C33.2862 20.151 34.4607 20.7067 35.3204 21.6221C36.18 22.5374 36.6611 23.7444 36.6667 25.0001C36.6667 26.3262 36.1399 27.5979 35.2022 28.5356C34.2645 29.4733 32.9927 30.0001 31.6667 30.0001ZM13.3333 21.6667H17.5833V26.6667H22.4167V21.6667H26.6667L20 15.0001L13.3333 21.6667Z"
          fill={isActive ? "#9945EE" : "#C4C4C4"}
        />
      </g>
      <defs>
        <clipPath id="clip0_795_104">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CloudIcon;
